var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('legend',{class:['micad_formLegend',_vm.getType(_vm.type)]},[_vm._v(_vm._s(_vm.legendText))])}
var staticRenderFns = []

export { render, staticRenderFns }